import {TweenLite} from 'gsap';


/** @enum {string} */
export const TICKER_EVENT_TYPES = {
  TICK: 'tick',
};


/** @type {TweenLite.ticker} */
export const ticker = TweenLite.ticker;
